'use client'
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel'
import { TestimonialCard } from './testomonial-card'
import Autoplay from 'embla-carousel-autoplay'

const TestomonialsCards3 = ({ testimonials, image }: { testimonials: any[]; image: any }) => {
  return (
    <section className="container mx-auto relative" aria-label="Testimonials">
      <div className="flex flex-wrap gap-10">
        {/* Carousel Column */}
        <section
          className="w-full lg:w-1/2 xl:w-5/12 mt-10 lg:mt-[40px] ml-[10px] z-40"
          aria-label="Testimonial List"
        >
          <Carousel
            opts={{
              loop: true,
            }}
            plugins={[
              Autoplay({
                delay: 3000,
                stopOnInteraction: false,
                stopOnMouseEnter: true,
                stopOnFocusIn: true,
              }),
            ]}
            aria-label="Testimonials carousel"
          >
            <CarouselContent>
              {testimonials.map((testimonial) => (
                <CarouselItem key={testimonial.id} className="w-full" role="listitem">
                  <article>
                    <TestimonialCard
                      quote={testimonial.description}
                      name={testimonial.name}
                      title={testimonial.title}
                      avatar={testimonial.photo}
                      rating={testimonial.rating}
                    />
                  </article>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </section>

        {/* Image Column */}
        <aside className="w-full lg:w-1/2 lg:ml-[-110px]" aria-label="Testimonial Image">
          <figure className="relative block">
            <img
              src={image?.url}
              alt="Testimonial Image"
              className="w-full lg:h-[42vh] picture-rounded object-cover"
            />
          </figure>
        </aside>
      </div>
    </section>
  )
}

export default TestomonialsCards3
